import { useEffect, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-3.svg";
import IconEdit from "../../assets/images/icon-edit.svg";
import IconDelete from "../../assets/images/icon-delete.svg";
import { MenuItem, Select } from "@mui/material";
import { formatDateByString } from "../../utils/default";

const Container = styled.div`
    width: 100%;
    overflow-y: auto;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    .header-table-box {
        height: 52px;
        background-color: #F2F5FE;

        .header-div {
            cursor: pointer;
        }

        th {
            color: #25368D;
            font-size: 15px;
            font-weight: 500;
            line-height: 22.43px;
            text-align: left;
            padding: 0px 16px;
        }

        .width-60 {
            width: 60%;
        }

        .width-20 {
            width: 20%;
        }

        .width-160px {
            width: calc(160px - 32px);
            max-width: calc(160px - 32px);
            min-width: calc(160px - 32px);
        }

        .width-70px {
            width: calc(70px - 32px);
            max-width: calc(70px - 32px);
            min-width: calc(70px - 32px);
        }

        .image-arrow {
            margin-left: 8px;
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }

    }

    .row-table-box {

        td {
            padding: 24px 16px;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: #F2F2F2;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .icon-edit {
            cursor: pointer;
            width: 16px;
        }

        .icon-delete {
            cursor: pointer;
            width: 28px;
        }

        .dropdown {
            width: 100%;
            height: 30px;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
            border-radius: 24px;

            &.ACTIVE {
                background-color: #DFF7F1;
            }

            &.INACTIVE {
                background-color: #F7F7FD;
            }
        }

        .status-line {
            width: 100%;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;

            .status-box {
                width: 14px;
                height: 14px;
                border-radius: 4px;
                margin-top: 1px;
                margin-right: 8px;

                &.ACTIVE {
                    background-color: #69D85F;
                }

                &.INACTIVE {
                    background-color: #D6DFE8;
                }
            }
        }

        .action-box {
            gap: 4px;
        }
    }
`;

function TableUserComponent({
    listData,
    order,
    onUpdate,
    onDelete,
    onChangeStatus,
    onOrder,
}) {
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "displayname",
    })
    const [rows, setRows] = useState([
        {
            id: "",
            username: "",
            firstname: "",
            displayname: "",
            department_displayname: "",
            division_displayname: "",
            last_login: "",
            line_status: "",
            status: "",
        },
    ])

    useEffect(() => {
        if (Array.isArray(listData)) {
            let list = JSON.parse(JSON.stringify(listData));
            list = list.map(x => {
                let detail = {
                    id: x.user_user_id,
                    username: x.user_username,
                    firstname: x.user_firstname,
                    displayname: x.user_displayname ? x.user_displayname.trim() : (`${x.user_firstname || ""} ${x.user_lastname || ""}`).trim(),
                    department_displayname: x.department_department_name,
                    division_displayname: x.division_division_name,
                    last_login: x.user_token_created_at ? formatDateByString(x.user_token_created_at, "DD MMMM YYYY") : "",
                    line_status: x.user_line_user_id ? "ACTIVE" : "INACTIVE",
                    status: x.user_status,
                }
                return detail
            })
            setRows(list)
        }
    }, [listData])
    useEffect(() => {
        if (order) {
            setOrderOption(order)
        }
    }, [order])

    function handleSort(key) {
        let detail = { ...orderOption };
        if (detail.orderBy === key) {
            detail.order = detail.order === "ASC" ? "DESC" : "ASC";
        } else {
            detail.orderBy = key;
            detail.order = "DESC";
        }
        setOrderOption(detail);
        onOrder && onOrder(detail);
    }
    function handleChangeStatus(param) {
        onChangeStatus && onChangeStatus(param)
    }
    function handleUpdate(param) {
        onUpdate && onUpdate(param)
    }
    function handleDelete(param) {
        onDelete && onDelete(param)
    }

    return (
        <Container>
            <Table>
                <thead>
                    <tr className="header-table-box">
                        <ThBox
                            className={"width-60"}
                            label={"ชื่อ - สกุล"}
                            orderKey={"displayname"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-20"}
                            label={"ฝ่าย"}
                            orderKey={"department"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-20"}
                            label={"กอง"}
                            orderKey={"division"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"เข้าระบบล่าสุด"}
                            orderKey={"last_active"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"สถานะเชื่อมกับไลน์"}
                            orderKey={"line_status"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"สถานะสมาชิก"}
                            orderKey={"status"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <th className="width-70px"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((value, index) => {
                        return (
                            <TrBox
                                key={index}
                                dataItem={value}
                                onUpdate={handleUpdate}
                                onDelete={handleDelete}
                                onChangeStatus={handleChangeStatus}
                            />
                        )
                    })}
                    {rows.length === 0 &&
                        <TrNodataBox />
                    }
                </tbody>
            </Table>
        </Container>
    )
}

function ThBox({
    label,
    orderKey,
    order,
    orderBy,
    onSort,
    className,
}) {
    function handleSort() {
        onSort && onSort(orderKey)
    }
    return (
        <th className={`${className}`}>
            <div className="header-div vertical-center" onClick={handleSort}>
                {label}
                {orderBy === orderKey &&
                    <img
                        className={`image-arrow ${order === "DESC" ? "" : "open"}`}
                        alt="img"
                        src={IconArrow}
                    />
                }
            </div>
        </th>
    )
}

function TrBox({
    dataItem,
    onUpdate,
    onDelete,
    onChangeStatus,
}) {
    const [status, setStatus] = useState("INACTIVE");

    useEffect(() => {
        if (dataItem?.status) {
            setStatus(dataItem?.status)
        }
    }, [dataItem])

    function handleChangeStatus(event) {
        const value = event.target.value;
        setStatus(value);
        const detail = { ...dataItem }
        if (detail) {
            detail.status = value
        }
        onChangeStatus && onChangeStatus(detail)
    }
    function handleUpdate() {
        onUpdate && onUpdate(dataItem)
    }
    function handleDelete() {
        onDelete && onDelete(dataItem)
    }

    return (
        <tr className="row-table-box">
            <td>{dataItem?.displayname || '-'}</td>
            <td>{dataItem?.department_displayname || '-'}</td>
            <td>{dataItem?.division_displayname || '-'}</td>
            <td>{dataItem?.last_login || '-'}</td>
            <td>
                <div className="vertical-center status-line">
                    <div className={`status-box ${dataItem?.line_status || "INACTIVE"}`}></div>
                    {dataItem?.line_status === "ACTIVE" ? "เชื่อมแล้ว" : "ยังไม่เชื่อม"}
                </div>
            </td>
            <td>
                <Select
                    className={`dropdown ${status}`}
                    value={status}
                    onChange={handleChangeStatus}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value={"ACTIVE"}>Active</MenuItem>
                    <MenuItem value={"INACTIVE"}>In-Active</MenuItem>
                </Select>
            </td>
            <td>
                <div className="action-box content-center">
                    <img className="icon-edit" alt="img" src={IconEdit} onClick={handleUpdate} />
                    <img className="icon-delete" alt="img" src={IconDelete} onClick={handleDelete} />
                </div>
            </td>
        </tr>
    )
}

function TrNodataBox() {
    return (
        <tr className="row-table-box">
            <td colSpan="7" style={{ textAlign: "center" }}>ไม่มีข้อมูล</td>
        </tr>
    )
}

export default TableUserComponent;